import createReactComponent from '../createReactComponent';
var VolumeX = createReactComponent('VolumeX', [['polygon', {
  points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5',
  key: '16drj5'
}], ['line', {
  x1: '23',
  y1: '9',
  x2: '17',
  y2: '15',
  key: '12pqis'
}], ['line', {
  x1: '17',
  y1: '9',
  x2: '23',
  y2: '15',
  key: 'dt411t'
}]]);
export default VolumeX;